import { ApplicationRef, enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableDebugTools } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .then(moduleRef => {
    if (!environment.production) {
      const appRef = moduleRef.injector.get(ApplicationRef);
      const rootComponentRef = appRef.components[0];

      if (rootComponentRef) {
        enableDebugTools(rootComponentRef);
      }
    }

    return moduleRef;
  })
  .catch(err => console.error(err));
